/**
 * AccordionSection Component
 *
 * Section wrapper that renders a Bootstrap accordion list.
 * Styling uses Bootstrap utility class props consistent with other sections.
 */
import React, { useId } from "react";
import { filterClass } from "../../utils/class-utils";
import type { AccordionSectionProps } from "../types";

export function AccordionSection(props: AccordionSectionProps) {
  const {
    Items,
    paddingYClass = "py-section-md",
    bgClass = "no-class",
  } = props;

  // Generate unique ID for this accordion instance
  const reactId = useId();
  const accordionId = `accordion-${reactId.replace(/[^a-zA-Z0-9_-]/g, "")}`;

  const sectionClasses = [
    bgClass,
    filterClass(paddingYClass),
  ]
    .map(filterClass)
    .filter(Boolean)
    .join(" ");

  const containerClasses = [
  ]
    .filter(Boolean)
    .join(" ");

  /**
   * ===== CLASSES (frontend can edit here) =====
   */
  const classes = {
    section: ["section section-accordion", sectionClasses].filter(Boolean).join(" ").trim(),
    container: ["container-xl", containerClasses].filter(Boolean).join(" ").trim(),
    accordion: "accordion",
  };

  return (
    <section className={classes.section || undefined}>
      <div className={classes.container || undefined}>
        <div className={classes.accordion} id={accordionId}>
          {Items?.map((item, index) => {
            // Clone the item element to pass accordionParentId and add key
            const ItemComponent = item.type;
            return (
              // eslint-disable-next-line react/no-array-index-key
              <ItemComponent key={index} {...item.props} accordionParentId={accordionId} />
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default AccordionSection;


